import theme from '../../../lib/theme';

const {
  scale,
  layouts,
  colors,
  media
} = theme;

export default () => ({
  shares: {
    marginLeft: `-${scale.xs}`,
    marginRight: `-${scale.xs}`,
    paddingLeft: scale.xs,
    paddingRight: scale.xs,
    borderTop: `1px solid ${colors.light_grey}`,
    borderBottom: `1px solid ${colors.light_grey}`,

    [media.s.up]: {
      marginLeft: 0,
      marginRight: 0,
      paddingLeft: 0,
      paddingRight: 0,
      border: 'none',
    },
  },

  shareLink: {
    ...layouts.column,

    margin: `${scale.xxs} 0 ${scale.xxs} ${scale.xxs}`,
  },

  shareIcon: {
    boxSizing: 'content-box',
    width: 24,
    height: 24,
    filter:
      'invert(11%) sepia(8%) saturate(100%) hue-rotate(314deg) brightness(96%) contrast(91%)',

    '&:hover': {
      filter:
        'invert(16%) sepia(97%) saturate(7208%) hue-rotate(262deg) brightness(101%) contrast(102%)',
    },
  },
});
